'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('setpoint', {
        url: '/setpoint',
        template: '<setpoint></setpoint>'
    });
}



// WEBPACK FOOTER //
// ./client/app/setpoint/setpoint.routes.js